export default "__VITE_ASSET__4sSji4p3__"